import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import LOOKUP from 'constants/lookup';
import CardSimple from 'screens/components/basic/CardSimple';
import Body from './Body';
import Header from './Header';
import { getYearlySalesReport, getCsvReport } from 'actions/ReportsAction';
import { formInput, clearFormInput } from 'actions/FormActions';
import Pagination from 'screens/components/basic/Pagination';
import Button from 'screens/components/basic/Button';
import Grid from 'screens/components/basic/Grid';
import { reportYearlySalesReport } from 'utils/breadcrumbInfo';
import WithRouter from 'custom/withRouter';

class YearlySalesReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activePage: 1,
            itemsPerPage: 20,
            showBody: false,
            totalRow: 0,
            model: {
                beginDate: 0,
                endDate: 0,
                branch: 0
            }
        };

        this.showBody = this.showBody.bind(this)
    }

    componentWillMount() {
        const date = new Date()
        this.props.formInput(date.getFullYear(), `YearlySalesReportYear`);

        // this.cleanSearch();
        this.filter();
    }

    cleanSearch = () => {
        this.props.clearFormInput(`YearlySalesReportYear`);
        this.props.clearFormInput(`YearlySalesReportBranchOption`);

        this.setState(pState => {
            return {
                ...pState,
                activePage: 1
            };
        }, this.getReport);
    }

    filter = () => {
        this.setState(pState => {
            return {
                ...pState,
                activePage: 1
            };
        }, this.getReport);
    }

    showBody() {
        this.filter();
        this.setState({ showBody: true });

    }

    getReport = () => {
        let year = this.props.year || moment().format('YYYY');
        let branch = this.props.branch || this.props.loggedBranch;

        this.props.getYearlySalesReport({ year, branch });

    }

    downloadReport = () => {
        let beginDate = this.props.beginDate ? moment(this.props.beginDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let endDate = this.props.endDate ? moment(this.props.endDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let branch = this.props.branch || this.props.loggedBranch;

        this.props.getCsvReport(`reports/excel/yearlysales?beginDate=${beginDate}&endDate=${endDate}&branch=${branch}`, "yearlysales");

    }

    redirectToReport = () => {
        this.props.navigate("/report");
    }

    changePage = (e) => {
        this.setState(pState => {
            return {
                ...pState,
                activePage: e
            };
        }, this.getReport);
    }

    componentWillReceiveProps = (newProps) => {
        if (this.state.showBody) {
            const totalRow = newProps.yearlySalesReport.months.length > 0 ? newProps.months.list[0].totalRows : 0;
            this.setState({ totalRow: totalRow })
        }
    }

    render() {
        // let viewModel = this.getTaxViewModel();
        const totalRow = this.props.yearlySalesReport.length > 0 ? this.props.yearlySalesReport[0].totalRows : 0;

        return (
            <Grid headerContent={reportYearlySalesReport}>
                <div className="bg-light-opacity">
                    <div className="row m-0 pa-2">
                        <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                            <h2>{LOOKUP.report.yearlySalesReport.text} </h2>
                            <h5>{LOOKUP.report.yearlySalesReport.description}</h5>
                        </div>
                    </div>
                    <div className="pa-2">
                        <Header
                            loggedBranch={this.props.loggedBranch} branchOptions={this.props.brachOptions} filter={this.filter} download={this.downloadReport} showBody={this.showBody} />
                        {
                            this.state.showBody &&
                            <p className="text-right mt-2">
                                <i>Generated on : {moment().format('MMMM Do YYYY, h:mm:ss a')}</i>
                            </p>
                        }
                    </div>
                </div>
                <div id="patient-list-table">
                    {
                        this.state.showBody &&
                        <CardSimple>
                            <Body yearlySalesReport={this.props.yearlySalesReport} selectedyear={this.props.year} />

                            <Pagination
                                length={this.state.totalRow}
                                itemsPerPage={this.state.itemsPerPage}
                                activePage={this.state.activePage}
                                onPageChange={this.changePage}
                            />
                        </CardSimple>
                    }
                </div>
            </Grid>
        );
    }
}

const mapStateToProps = state => {
    let branches = state.common.userBranches || [];
    let brachOptions = [];
    branches.map((item) => {
        brachOptions.push({
            text: item.name, value: item.id.toString()
        });
    })
    return {
        brachOptions: brachOptions,
        yearlySalesReport: state.reports.yearlySalesReport,
        loggedBranch: state.common.branchId,
        year: state.form.YearlySalesYear,
        branch: state.form.YearlySalesReportBranchOption
    };
};

const mapDispatchToProps = dispatch => {
    return {
        getYearlySalesReport: model => dispatch(getYearlySalesReport(model)),
        clearFormInput: (name) => dispatch(clearFormInput(name)),
        formInput: (value, name) => dispatch(formInput(value, name)),
        getCsvReport: (url, name) => dispatch(getCsvReport(url, name))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(WithRouter(YearlySalesReport));